import { IMenuItem } from 'src/types/menu.types';
import { ItemResponse } from 'src/api/getItem/types';

// price band default
// price band exteral systems
// external sys default -- dont support // will be added in future
export const formatItemV2 = (item: ItemResponse): IMenuItem => {
  const itemDefaultPrice = item.prices?.find(
    (price) => price.external_system_id === null && price.price_band_id === null,
  );
  const priceBandDefaults = item.prices.filter(
    (price) => price.price_band_id !== null && price.external_system_id === null,
  );
  const prices = priceBandDefaults?.map((priceBand) => {
    const externalSystemPrices = item.prices.filter(
      (price) => price.price_band_id === priceBand.price_band_id && price.external_system_id !== null,
    );
    return {
      priceBandId: priceBand.price_band_id,
      priceBandDefaultPrice: priceBand.value_with_tax,
      priceBandTaxRate: priceBand.tax_rate,
      name: '',
      price_id: '',
      aggregators: externalSystemPrices?.map((externalSystemPrice) => ({
        aggregatorId: externalSystemPrice.external_system_id,
        aggregatorName: '',
        price: externalSystemPrice.value_with_tax,
        price_id: externalSystemPrice.price_id,
      })),
    };
  });
  return {
    itemId: item.item_id,
    code: item.code,
    name: item.name,
    consumerName: item.consumer_name,
    description: item.description,
    prices: {
      defaultPrice: itemDefaultPrice?.value_with_tax || 0,
      taxRate: item.tax_rate,
      priceBands: prices,
    },
    new_prices: item.prices,
    plu: item.plu,
    type: item.type,
    tax_rate: item.tax_rate,
    image: item.assets[0]?.asset_variants[0]?.url,
    displayOrder: item.display_order,
    parentItemId: item.fk_parent_item_id,
    optionGroup: item.modifier_groups?.map((optionGroup) => ({
      name: optionGroup.name,
      consumer_name: optionGroup.consumer_name,
      optionGroupId: optionGroup.pk_modifier_group_id,
      description: optionGroup.description,
      min: optionGroup.min_choices,
      max: optionGroup.max_choices,
      is_repeatable: optionGroup.is_repeatable,
      ranges: optionGroup.ranges || [],
      external_systems: optionGroup.external_systems || [],
      items: optionGroup.modifiers.map((item) => ({
        optionItemId: item.item_id,
        name: item.name,
        posId: item.plu,
        valueWithTax: item.value_with_tax,
        inheritPrice: item.inherit_price,
        inheritPosId: !item.plu,
      })),
    })),
    ranges: item.ranges || [],
    ...('rules' in item ? { rules: item.rules } : {}),
    recipe: item.recipe,
    deposit_return_scheme: item.deposit_return_scheme,
    regulatory_statements: item.regulatory_statements?.map((statement) => ({
      ...statement,
      name: typeof statement.name === 'string' ? statement.name : JSON.stringify(statement.name),
      description:
        typeof statement.description === 'string' ? statement.description : JSON.stringify(statement.description ?? ''),
    })),
    categories: item.categories || [],
  };
};
// used in v1 and v2 GET /items
export const formatItem = (item: any): IMenuItem => {
  return formatItemV2(item);
};
